// extracted by mini-css-extract-plugin
module.exports = {"section":"app-store-rating_section__8MBtu","rating":"app-store-rating_rating__ojj1G","reviews":"app-store-rating_reviews__au_47"};